var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.273 5.037a2.42 2.42 0 0 1 2.418 2.418v9.09a2.42 2.42 0 0 1-2.418 2.418h-9.091c-.601 0-1.18-.223-1.625-.627l-5.753-5.22a1.51 1.51 0 0 1 0-2.234l5.753-5.218a2.42 2.42 0 0 1 1.625-.627zm-9.091 1.199c-.303 0-.595.113-.819.316L3.61 11.771a.31.31 0 0 0 0 .457l5.753 5.22c.224.203.516.315.819.315h9.09a1.22 1.22 0 0 0 1.22-1.218v-9.09a1.22 1.22 0 0 0-1.22-1.22zM17.1 8.919a.5.5 0 0 1 .707.707L15.434 12l2.374 2.374a.5.5 0 0 1-.707.706l-2.374-2.373-2.373 2.373a.5.5 0 0 1-.707-.707L14.02 12l-2.373-2.374a.5.5 0 0 1 .707-.707l2.373 2.374z"
  })));
};
export default SvgDelete;